export class DepthState {
}
